import { Box, List, Skeleton, Typography } from '@mui/material';
import React from 'react';

export const SkeletonCommentList = () => (
  <Box sx={{ height: '100%', width: '93%', boxShadow: 'none' }}>
    <List sx={{ width: '100%', height: '78vh', overflow: 'auto', padding: 0 }}>
      {[...Array(2)].map((_, index) => (
        <React.Fragment key={index}>
          {[...Array(2)].map((_, idx) => (
            <SkeletonCommentItem key={idx} isOwnMessage={idx % 2 !== 0} />
          ))}
        </React.Fragment>
      ))}
    </List>
  </Box>
);

const SkeletonCommentItem = ({ isOwnMessage }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: 2,
      flexDirection: isOwnMessage ? 'row-reverse' : 'row',
    }}
  >
    {isOwnMessage ? null : (
      <Skeleton variant='circular' width={35} height={30} sx={{ marginRight: 1, marginLeft: 2 }} />
    )}
    <Box sx={{ width: '100%' }}>
      <Box sx={{ width: '100%', display: 'flex', flexDirection: isOwnMessage ? 'row-reverse' : 'row' }}>
        <Skeleton variant='text' width='30%' height={20} sx={{ marginBottom: 1 }} />
      </Box>
      <SkeletonChatBubble isOwnMessage={isOwnMessage} />
    </Box>
  </Box>
);

const SkeletonChatBubble = ({ isOwnMessage }) => (
  <Box
    sx={{
      borderRadius: 3,
      backgroundColor: '#EEF5FF',
      padding: '8px 12px',
      maxWidth: '85%',
      wordWrap: 'break-word',
      marginLeft: isOwnMessage ? 'auto' : 0,
      marginRight: isOwnMessage ? 0 : 'auto',
      borderTopRightRadius: isOwnMessage ? 0 : null,
      borderTopLeftRadius: isOwnMessage ? null : 0,
    }}
  >
    <Skeleton variant='text' width='100%' height={15} />
    <Skeleton variant='text' width='100%' height={15} />

    {isOwnMessage ? null : <Skeleton variant='text' width='100%' height={15} />}
    <Skeleton variant='text' width='30%' height={15} />
  </Box>
);
